import { apiService } from '../services/ApiService';

export const PERMISSION_LISTS = {
  general: { key: 'capabilities', fn: apiService.getMeRole },
  kiosk: { key: 'capabilitiesKiosk', fn: ()=>{}},
  petrol: { key: 'capabilitiesPetrol', fn: apiService.getMePetrolRole  },
};

export const DEFAULT_PERMISSIONS_LIST = 'petrol';
